import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setTppHiddenRows, setTppHiddenSections, setTppShowContext } from '../../redux/actions'
import { RootState } from '../../redux/types'

export interface TppFilters {
    hiddenSectionIds: string[]
    hiddenRowIds: string[]
    showContext?: boolean
}

export const useTppFiltersStorage = () => {
    const dispatch = useDispatch()
    const filters = useSelector((state: RootState) => state.tppFilters)

    const updateFilters = useCallback(
        (newFilters: TppFilters) => {
            dispatch(setTppHiddenSections(newFilters.hiddenSectionIds))
            dispatch(setTppHiddenRows(newFilters.hiddenRowIds))
        },
        [dispatch]
    )

    const updateShowContext = useCallback(
        (showContext: boolean) => {
            dispatch(setTppShowContext(showContext))
        },
        [dispatch]
    )

    return {
        filters,
        updateFilters,
        updateShowContext,
    }
}
